import { render, staticRenderFns } from "./FraudTrips.vue?vue&type=template&id=03f3ba30&"
import script from "./FraudTrips.vue?vue&type=script&lang=js&"
export * from "./FraudTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports